// FAQ accordion close-transition fix (PLAN.md build order item 10 craft pass).
//
// Opening a <details> element and letting CSS drive grid-template-rows
// 0fr->1fr (component-sj-blog.css) transitions smoothly. Closing doesn't:
// browsers suppress rendering of a <details>'s non-summary content
// essentially synchronously with the `open` attribute being removed, which
// can cut the CSS transition short regardless of any author override —
// a well-documented limitation of pure-CSS <details> disclosure animation,
// not something specificity or !important can fix. The fix is to delay
// removing `open` until the shrink animation has actually finished:
// intercept the close click, drive grid-template-rows to 0fr via an inline
// style while `open` is still present (so the content is still rendered
// and the transition plays in full), then remove `open` once the
// transition ends. Opening is untouched — native <details> toggle handles
// it, since that direction was already smooth.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('.sj-article__faq').forEach((details) => {
    const summary = details.querySelector('summary');
    const wrap = details.querySelector('.sj-article__faq-answer-wrap');
    if (!summary || !wrap) return;

    summary.addEventListener('click', (event) => {
      if (!details.open) return; // opening: let the native toggle proceed as-is

      event.preventDefault();
      wrap.style.gridTemplateRows = '0fr';

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        details.removeAttribute('open');
        wrap.style.gridTemplateRows = '';
        wrap.removeEventListener('transitionend', onTransitionEnd);
      };

      function onTransitionEnd(e) {
        if (e.target === wrap && e.propertyName === 'grid-template-rows') finish();
      }

      wrap.addEventListener('transitionend', onTransitionEnd);
      // Fallback in case transitionend doesn't fire (e.g. the property was
      // already at 0fr for some reason) — slightly longer than the 300ms
      // CSS transition so it never races a legitimate transitionend.
      setTimeout(finish, 400);
    });
  });
})();
